var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.999,
    height: 14,
    viewBox: "0 0 13.999 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_importa",
    "data-name": "icona importa",
    transform: "translate(-3609.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_96",
    "data-name": "Tracciato 96",
    d: "M2.943,10.891a.724.724,0,0,0,1.024,0L6.7,8.161A.724.724,0,1,0,5.674,7.136L4.179,8.631V.724a.724.724,0,0,0-1.448,0V8.631L1.236,7.136A.724.724,0,1,0,.212,8.161Z",
    transform: "translate(3609.001 10.455) rotate(-90)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_97",
    "data-name": "Tracciato 97",
    d: "M13.276,0a.724.724,0,0,0-.724.724V6.276H1.448V.724A.724.724,0,1,0,0,.724V6.517A1.207,1.207,0,0,0,1.207,7.724H12.793A1.207,1.207,0,0,0,14,6.517V.724A.724.724,0,0,0,13.276,0Z",
    transform: "translate(3615.276 14) rotate(-90)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.7b46155c3ccb05c9c0b19c9495f5180a.svg";
export { ForwardRef as ReactComponent };